/**
 * This module has the .tsx extension to make sure it's analyzed by UnoCSS.
 */

export function preventUserInteractions() {
  const element = document.createElement('div');

  element.classList.add('fixed', 'inset-0', 'z-[9999]', 'pointer-events-auto');

  element.addEventListener('pointerdown', (e) => {
    e.stopPropagation();
  });

  document.body.appendChild(element);

  return () => {
    element.remove();
  };
}
